/**
 * Centralized API and Cloud Functions configuration
 */

const FUNCTIONS_BASE_URL = process.env.REACT_APP_FUNCTIONS_BASE_URL ||
  'https://asia-south1-apkakhata-84547.cloudfunctions.net';

export const API = {
  // Relative paths (proxied/rewritten in hosting)
  contact: '/api/contact',
  sendCallRequest: '/api/send-call-request',
  trackReferral: '/api/website-owner/track-referral',
  updateReferralStatus: '/api/website-owner/update-referral-status',
  updateTierTracking: '/api/website-owner/update-tier-tracking',
};

export const FUNCTIONS = {
  baseUrl: FUNCTIONS_BASE_URL,
  createSecurityDepositOrder: `${FUNCTIONS_BASE_URL}/createSecurityDepositOrder`,
  verifySecurityDepositPayment: `${FUNCTIONS_BASE_URL}/verifySecurityDepositPayment`,
  createWebsiteOwnerHTTP: `${FUNCTIONS_BASE_URL}/createWebsiteOwnerHTTP`,
};
